const breakpointsValues = ['320px', '392px', '481px', '708px', '889px', '1440px', '1920px'];

const breakpoints = {
    mobile320: breakpointsValues[0],
    mobile392: breakpointsValues[1],
    mobile481: breakpointsValues[2],
    tablet708: breakpointsValues[3],
    tablet889: breakpointsValues[4],
    desktop1440: breakpointsValues[5],
    desktop1920: breakpointsValues[6],
};

export { breakpoints };
